import { useState } from 'react';

// Resetting during render, not in an effect, keeps the render after a change from building a query
// at the old position: useQuery sends during render, so an effect's reset arrives one query too late.
export default function usePagePosition({ resetKey, filters, initialPosition }) {
  const [paging, setPaging] = useState({ resetKey, filters, position: initialPosition });

  const isCurrent = paging.resetKey === resetKey && paging.filters === filters;
  if (!isCurrent) setPaging({ resetKey, filters, position: initialPosition });

  const position = isCurrent ? paging.position : initialPosition;
  const setPosition = next => setPaging({ resetKey, filters, position: next });

  return [position, setPosition];
}
